import { GeoDsDocument } from '@barthauer/custom/xmt-models';

export enum SupportType {
  legal = 'Rechtlicher',
  technical = 'Technischer',
}

export class SupportTicket {
  SupportType: SupportType;
  Subject: string;
  Description: string;
  Attachments?: GeoDsDocument[];

  constructor(data: SupportTicket) {
    Object.assign(this, data);
  }
}

export class Person {
  Company : string ;
  EMail : string ; 
  FullName : string ; 
  constructor(data: Person) {
    Object.assign(this, data);
  }
}

export interface Email {
  From: string;
  To: string;
  Cc: string[];
  Subject: string;
  Body: string;
}

export interface ImageFile {
  file: File;
  base64: string;
}
